import { Keycap, Modal } from '../common/index.jsx';

/**
 * Generated from one table that also documents the bindings used in the workspace, so
 * the help cannot drift from the actual shortcuts.
 */
export const SHORTCUTS = [
  {
    group: 'Tag the selection',
    items: [
      { keys: ['h'], what: 'Hallucination' },
      { keys: ['u'], what: 'Uncertain' },
      { keys: ['w'], what: 'Wrong uncertainty' },
      { keys: ['dbl-click'], what: 'Select a whole word' },
      { keys: ['click'], what: 'Type directly in the caption to edit it' },
      { keys: ['esc'], what: 'Clear the selection' },
    ],
  },
  {
    group: 'Move between tags',
    items: [
      { keys: ['j'], what: 'Next tag' },
      { keys: ['k'], what: 'Previous tag' },
      { keys: ['d'], what: 'Set action: remove' },
      { keys: ['r'], what: 'Set action: replace' },
      { keys: ['⌫'], what: 'Delete the tag under the cursor' },
    ],
  },
  {
    group: 'Captions and images',
    items: [
      { keys: ['1', '2', '3'], what: 'Focus caption A / B / C' },
      { keys: ['tab'], what: 'Next caption' },
      { keys: ['←'], what: 'Previous image' },
      { keys: ['→'], what: 'Next image' },
      { keys: ['z'], what: 'Toggle zoom' },
    ],
  },
  {
    group: 'Saving',
    items: [
      { keys: ['⇧', '⏎'], what: 'Mark image done and go to the next one' },
      { keys: ['⌘', 's'], what: 'Save now' },
      { keys: ['g'], what: 'Open the guidelines' },
      { keys: ['?'], what: 'This cheatsheet' },
    ],
  },
];

export function ShortcutCheatsheet({ onClose }) {
  return (
    <Modal title="Keyboard shortcuts" onClose={onClose} width="min(760px, 100%)">
      <div className="cheatsheet-grid">
        {SHORTCUTS.map((group) => (
          <div key={group.group} className="cheatsheet-group">
            <h4>{group.group}</h4>
            {group.items.map((item) => (
              <div key={item.what} className="cheatsheet-row">
                <span>{item.what}</span>
                <span className="keys">
                  {item.keys.map((key) => (
                    <Keycap key={key}>{key}</Keycap>
                  ))}
                </span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </Modal>
  );
}
